import API_CLIENT from "../../utils/Api";

export async function GetStoreBoxes() {
  return await API_CLIENT.get(`/store-boxes`);
}
